import React from 'react';

import { Tooltip } from '@primer/react';

export const WithTooltip = ({
  children, label = '', showTooltip = false, tooltipProps = {} 
}) => {
  if (showTooltip) {
    return (
      <Tooltip aria-label={label} {...tooltipProps}>
        { children }
      </Tooltip>
    )
  }

  return children;
}

export default WithTooltip;
